import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../Constant/colors";

const Examination = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "white",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    padding: "18px 20px",
    display: "flex",
    alignItems: "center",
    gap: "18px",
    cursor: "pointer",
    transition: "0.2s",
    minHeight: "120px",
    height: "100%",
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
  };

  const subheading = {
    fontSize: "12px",
    opacity: 0.7,
    marginTop: "2px",
  };

  const iconStyle = {
    fontSize: "32px",
    minWidth: "40px",
  };

  const titleStyle = {
    fontWeight: "700",
    color: colors.grayDark,
  };

  return (
    <div style={{ background: "#ffffff", minHeight: "100vh" }} className="flex justify-center items-start p-6">
      <div className="w-full max-w-7xl">

        {/* Page Title */}


        {/* Grid: 3 columns on desktop, 1 on mobile */}
        <div className={`grid gap-6 ${isMobile ? "grid-cols-1" : "grid-cols-3"}`} style={{ alignItems: "stretch" }}>

          {/* Examination Datesheet */}
          <Link to="/exam-datesheet" className="flex">
            <div style={cardStyle} className="hover:scale-[1.01] w-full">
              <i className="fas fa-calendar-alt" style={{ ...iconStyle, color: "#F59E0B" }}></i>
              <div>
                <h2 style={heading}>Examination Datesheet</h2>
                <p style={subheading}>Manage and view exam datesheets.</p>
              </div>
            </div>
          </Link>

          {/* Examination Results */}
          <Link to="/exam-results" className="flex">
            <div style={cardStyle} className="hover:scale-[1.01] w-full">
              <i className="fas fa-chart-bar" style={{ ...iconStyle, color: "#3B82F6" }}></i>
              <div>
                <h2 style={heading}>Examination Results</h2>
                <p style={subheading}>Manage and view examination results.</p>
              </div>
            </div>
          </Link>

          {/* Test Schedule */}
          <Link to="/test-schedule" className="flex">
            <div style={cardStyle} className="hover:scale-[1.01] w-full">
              <i className="fas fa-calendar-check" style={{ ...iconStyle, color: "#10B981" }}></i>
              <div>
                <h2 style={heading}>Test Schedule</h2>
                <p style={subheading}>Manage and view class-wise test schedule.</p>
              </div>
            </div>
          </Link>

          {/* Old Papers */}
          <Link to="/old-papers" className="flex">
            <div style={cardStyle} className="hover:scale-[1.01] w-full">
              <i className="fas fa-file-alt" style={{ ...iconStyle, color: "#8B5CF6" }}></i>
              <div>
                <h2 style={heading}>Old Papers</h2>
                <p style={subheading}>Manage and view previous year question papers.</p>
              </div>
            </div>
          </Link>

          {/* Class Toppers */}
          <Link to="/class-toppers" className="flex">
            <div style={cardStyle} className="hover:scale-[1.01] w-full">
              <i className="fas fa-trophy" style={{ ...iconStyle, color: "#D97706" }}></i>
              <div>
                <h2 style={heading}>Class Toppers</h2>
                <p style={subheading}>View toppers with class & section filters.</p>
              </div>
            </div>
          </Link>


        </div>
      </div>
    </div>
  );
};

export default Examination;
